import Marionette from 'backbone.marionette';
import committeeMeetingItemviewTmpl from '../templates/committee_meeting_itemview.tpl';
export default Marionette.ItemView.extend({
  template: committeeMeetingItemviewTmpl,
  tagName: "div",
  className: "border-bottom pb-2 mb-2"
});